<template>
  <v-card :loading="loading">
    <v-card-title class="font-weight-regular">
      {{ $t('EMPLOYEES.ADDITIONAL_INFORMATION') }}
      <v-icon
        v-if="!editMode"
        class="ml-2"
        color="indigo"
        @click="toggleEditMode"
      >
        mdi-square-edit-outline
      </v-icon>
      <v-spacer></v-spacer>
      <v-checkbox
        v-model="form.additional_information.is_service_employee"
        name="is_service_employee"
        class="pr-4"
        :label="$t('EMPLOYEES.SERVICE_EMPLOYEE')"
        :disabled="!editMode"
        :error="errors.is_service_employee"
      ></v-checkbox>
      <v-checkbox
        v-model="form.additional_information.is_concierge"
        name="is_concierge"
        :label="$t('BUILDING_COMPLEXES.CONCIERGE')"
        :disabled="!editMode"
        :error="errors.is_concierge"
      ></v-checkbox>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <employee-additional-information-form
          v-model="form.additional_information"
          :readonly="!editMode"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />

        <v-row dense>
          <v-col cols="12" class="pt-0">
            <div v-if="editMode">
              <v-btn
                outlined
                class="mr-5"
                depressed
                color="grey"
                large
                v-on="{
                  click: [reset, cancel]
                }"
              >
                {{ $t('BUTTON.CANCEL') }}
              </v-btn>
              <v-btn
                depressed
                type="submit"
                :disabled="!valid"
                large
                color="primary"
                class="mr-5"
                @click.prevent="update"
              >
                {{ $t('BUTTON.UPDATE') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import EmployeeAdditionalInformationForm from '../components/forms/EmployeeAdditionalInformationForm';
import editComponent from '@/modules/_global/mixins/edit-component';
import getAdditionalInfo from '@/modules/employees/components/mixins/get-additional-info';
import { EmployeesService } from '@/services/employees.service';

export default {
  name: 'EmployeeAdditionalInformation',

  components: {
    EmployeeAdditionalInformationForm
  },

  mixins: [errors, editComponent, getAdditionalInfo],

  methods: {
    update() {
      EmployeesService.updateAdditionalInfo(
        this.form.id,
        this.getAdditionalInformation
      )
        .then(data => {
          this.toggleEditMode();
          this.$emit('update', data);
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
